import { NgModule } from '@angular/core'
import { BulkOperationAnnouncementsComponent } from './bulk-operation-announcements.component'
import { NgClickOutsideDirective } from 'ng-click-outside2'
import { BulkOperationPipesModule } from '../../../features/bulk-operation/pipes/bulk-operation-pipes.module'
import { LoadingModule } from '../../../shared/ui/loading/loading.module'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

@NgModule({
    imports: [
        NgClickOutsideDirective,
        BulkOperationPipesModule,
        LoadingModule,
        CommonModule,
        FormsModule,
        RouterModule,
    ],
    declarations: [
        BulkOperationAnnouncementsComponent
    ],
    exports: [
        BulkOperationAnnouncementsComponent
    ]
})
export class BulkOperationAnnouncementsModule {}